exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "button {\r\n  height: 40px;\r\n  margin-right: 5px;\r\n  border-radius: 0;\r\n  min-width: 80px;\r\n}\r\n\r\n:host {\r\n  display: block;\r\n  height: 50px;\r\n}", ""]);

